module.exports = __webpack_public_path__ + "img/cover-yab.85ee427a.jpg";